import Select from 'components/Formik/Select';
import Text from 'components/Formik/Text';
import { useEffect } from 'react';

const LeadSourceDetails = ({ formik, initialValues, data }) => {
	initialValues.Lead_Source_Details__c = '';
	initialValues.Others__c = '';
	useEffect(() => {
		formik.values.Others__c = '';
	}, [formik.values.Lead_Source_Details__c]);
	const { lead_source_details, other } = data;
	return (
		<>
			<Select
				label={lead_source_details.label}
				name='Lead_Source_Details__c'
				options={lead_source_details.options}
				placeholder={lead_source_details.placeholder}
			/>
			{formik.values.Lead_Source_Details__c === 'Other' && (
				<>
					<Text label={other} name='Others__c' type='text' />
				</>
			)}
		</>
	);
};

export default LeadSourceDetails;
